import { Button } from "@/components/ui/button";
import { Sparkles, Loader2 } from "lucide-react";
import { THEMES } from "./StepTheme";
import { STYLES } from "./StepStyle";

export default function StepReview({ child, story, loading, onSubmit }) {
  const themeLabel = THEMES.find((t) => t.id === story.theme)?.label;
  const styleLabel = STYLES.find((s) => s.id === story.illustration_style)?.label;
  return (
    <div className="space-y-5 text-center" data-testid="step-4">
      <h1 className="font-display text-3xl font-bold text-[#2B2D42]">Ready to see the magic?</h1>
      <p className="text-[#4A4E69]">We'll generate a free cover + first page just for {child.name}. Then decide.</p>
      <div className="paper-card p-6 text-left text-sm space-y-1">
        <div><strong>Star of the story:</strong> {child.name}, age {child.age}</div>
        <div><strong>Look:</strong> {child.hair}, {child.skin_tone} skin</div>
        <div><strong>Theme:</strong> {themeLabel}</div>
        <div><strong>Style:</strong> {styleLabel}</div>
        {story.custom_prompt && <div><strong>Your idea:</strong> {story.custom_prompt}</div>}
      </div>
      <Button data-testid="generate-preview-btn" disabled={loading} onClick={onSubmit}
        className="bg-[#E07A5F] hover:bg-[#D96B43] text-white text-base px-8 py-6 rounded-full">
        {loading
          ? (<><Loader2 className="animate-spin mr-2" size={16} /> Weaving your preview…</>)
          : (<><Sparkles size={16} className="mr-2" /> Show me the preview — free</>)}
      </Button>
    </div>
  );
}
